import React from 'react'
import PropTypes from 'prop-types';

/** css file */
import "./Contracts.scss"
import SubLayout from '../../layouts/components/subLayout/SubLayout';

const Contracts = (WrappedComponent) => {
  const ChildComponent = (props) => (

    <SubLayout>
      <WrappedComponent {...props} />
    </SubLayout>
  );

  return ChildComponent;
}

Contracts.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
};

export default Contracts